import type { TourStep } from '../types';

export const companyProfileSteps: TourStep[] = [
  {
    target: '[data-tour="company-section"]',
    title: 'Company Profile',
    content:
      'Everything here flows into your appraisal reports, engagement letter headers, and public website. Keep it accurate — clients and reviewers will see it.',
    placement: 'bottom',
    route: '/business?tab=company',
  },
  {
    target: '[data-tour="company-info"]',
    title: 'Fill in Your Firm Details',
    content:
      'Enter your company name, address, phone, and email. These auto-populate on reports and letters so you never have to type them again. Try updating a field.',
    placement: 'bottom',
    route: '/business?tab=company',
    isActionStep: true,
    spotlightClicks: true,
    nextButtonText: 'I\'ve reviewed this',
  },
  {
    target: '[data-tour="company-logo"]',
    title: 'Upload Your Logo',
    content:
      'Add your company logo here. It appears on your website header, report cover pages, and engagement letter letterhead. Square or landscape formats work best.',
    placement: 'bottom',
    route: '/business?tab=company',
    isActionStep: true,
    spotlightClicks: true,
    nextButtonText: 'Got it',
  },
  {
    target: '[data-tour="company-social"]',
    title: 'Social Media Links',
    content:
      'Add your LinkedIn, Facebook, or other profiles. These display on your public website footer so potential clients can find and connect with you.',
    placement: 'top',
    route: '/business?tab=company',
    spotlightClicks: true,
  },
];
